export default __webpack_public_path__ + "static/media/footer4.fb9eddd8.jpg";